import classNames from 'classnames';
import React, { ReactElement, useContext } from 'react';

import { IParentProps } from '../../shared/types/IParentProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import { TAB_NAVIGATION_SIZES } from './TAB_NAVIGATION_SIZES';
import { ITabHeaderContext, TabHeaderContext } from './TabHeaderContext';
import { ITabNavigationContext, TabNavigationContext } from './TabNavigationContext';

type ITabHeaderProps = IParentProps & IStyleableProps & {
    index: number;
    size: TAB_NAVIGATION_SIZES;
};

export function OzTabHeader (props: ITabHeaderProps): ReactElement | null {
    const {
        children,
        className = '',
        index,
        size,
    }: ITabHeaderProps = props;

    const tabNavigation: ITabNavigationContext = useContext(TabNavigationContext);

    if (!tabNavigation) {
        return null;
    }

    const { activeIndex, navigateToTab }: Exclude<ITabNavigationContext, null> = tabNavigation;
    const isNavLinkActive: boolean = index === activeIndex;

    const tabHeaderClassNames: string = classNames({
        'hover:cursor-pointer font-gellix font-bold inline-block': true,
        'text-gray-500 hover:text-gray-600': !isNavLinkActive,
        'text-gray-900': isNavLinkActive,
        'text-base': size === TAB_NAVIGATION_SIZES.SMALL,
        'text-med': size === TAB_NAVIGATION_SIZES.MEDIUM,
        'text-lg': size === TAB_NAVIGATION_SIZES.LARGE,
        [className]: !!className,
    });

    const contextValue: ITabHeaderContext = {
        index,
    };

    return (
        <TabHeaderContext.Provider value={contextValue}>
            <div
                className={tabHeaderClassNames}
                key={index}
                onClick={(): void => {
                    navigateToTab(index);
                }}
            >
                {children}
            </div>
        </TabHeaderContext.Provider>
    );
}
